/**
 * Created by Andrey Popov on 15.08.26
 */

const TryRewardedPromoWindow = Prefab.createWindow("try_rewarded_promo_window", "tryrewardedpromowindow_prefab_json", {
    bundles: () => ["rewarded_promo_window"]
});
